import { render, staticRenderFns } from "./JiraTask.vue?vue&type=template&id=6cd81ece&"
import script from "./JiraTask.vue?vue&type=script&lang=js&"
export * from "./JiraTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports